/**
 * @file
 * A JavaScript file containing footer block folding functionality
 *
 */

(function (Drupal, $) {
  Drupal.behaviors.siteFooter = {
    attach: function (context) {
      if (window.matchMedia("(min-width: " + 920 + "px)").matches) {
        var tradingHours = $(".trading-hours__items")
       
        if (tradingHours.length) {
          var tradingOffset =
          tradingHours.offset().top -
          tradingHours.parent().parent().offset().top;
        }

        var fundmaster = $("#block-findusmaster"),
          copyright = $("#block-copyrightfooterblock");

        if (fundmaster.length) {
          var findUsOffset =
            fundmaster.offset().top - fundmaster.parent().offset().top;

          if (tradingOffset - findUsOffset > 0) {
            fundmaster.css("margin-top", tradingOffset - findUsOffset + "px");
          }
        }
        if (copyright.length) {
          var copyrightOffset =
            copyright.offset().top - copyright.parent().offset().top;

          if (tradingOffset - copyrightOffset > 0) {
            copyright.css("margin-top", tradingOffset - copyrightOffset + "px");
          }
        }
      }
    },
  };
})(Drupal, jQuery);
